export function reservationPagePath(code) {
  return `/reservation/${encodeURIComponent(String(code))}/`
}

export function reservationPageUrl(code) {
  if (typeof window === 'undefined') {
    return reservationPagePath(code)
  }

  return new URL(reservationPagePath(code), window.location.origin).href
}

/** Gatsby develop webpack chunk for `src/pages/reservation/[code].js`. */
const RESERVATION_TRACKER_DEV_CHUNK =
  '/component---src-pages-reservation-%5Bcode%5D-js.js'

let reservationTrackerWarmStarted = false

/**
 * Warm the tracker page chunk (and Gatsby develop compile) before opening a tab.
 * Safe no-op when the loader is unavailable (SSR / production edge).
 */
export function prefetchReservationTracker(code = 'warm') {
  if (typeof window === 'undefined') return
  const path = reservationPagePath(code)
  try {
    window.___loader?.enqueue?.(path)
  } catch {
    // Prefetch is best-effort.
  }

  // In develop, also poke the webpack chunk URL so compile starts even when the
  // Gatsby loader queue is idle (new-tab opens were waiting ~60–90s on white).
  if (
    process.env.NODE_ENV === 'development' &&
    !reservationTrackerWarmStarted
  ) {
    reservationTrackerWarmStarted = true
    fetch(RESERVATION_TRACKER_DEV_CHUNK, { priority: 'low' }).catch(() => {})
    // Warm the lazy tracker app module (separate async chunk from the thin page).
    void import('../components/ReservationTracker/ReservationTrackerApp').catch(() => {})
  }
}

/**
 * Open a reservation tracker in a new browser tab.
 * Uses window.open so Gatsby/client routers cannot intercept the navigation.
 *
 * Do not pass `noopener` in windowFeatures: browsers then return `null` even when
 * the tab opened, which would incorrectly run the <a> fallback and open a second tab.
 * We null out `opener` manually instead.
 */
export function openReservationInNewTab(code, event) {
  if (typeof window === 'undefined') return false

  const url = reservationPageUrl(code)

  if (event) {
    if (event.defaultPrevented) return false
    if (typeof event.button === 'number' && event.button !== 0) return false
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return false
    }
    event.preventDefault()
    event.stopPropagation()
  }

  // Prefetch right before open so a hover-miss still warms the chunk when possible.
  prefetchReservationTracker(code)

  // Do not add an <a target=_blank> fallback after window.open: browsers can
  // return null for the Window while still opening the tab, which would open two.
  const tab = window.open(url, '_blank')
  if (tab) tab.opener = null
  return Boolean(tab)
}
